import moment from "moment";

const today = new Date();
let offset = 1;

if (moment(today).isDST()) {
  offset = 2;
}

const msToKnotsMulitplier = 1.94384;

const config = {
  timeCorrection: offset,
  msToKnotsMulitplier
};

export default config;
